import React from 'react'
import { theme } from 'antd'
import { spacing } from '@vacationtracker/shared/constants/ThemeSetting'

export interface HeaderRuleProps {
  /** Space above the line. Defaults to the same gap the header keeps between its own rows. */
  gap?: 'none' | 'xs' | 'sm'
}

const GAP: Record<NonNullable<HeaderRuleProps['gap']>, number> = {
  none: 0,
  xs: spacing.xs,
  sm: spacing.sm,
}

/**
 * The line that closes a page header.
 *
 * It separates chrome from content: without it a dense settings screen reads as one long column and
 * the trail above the title looks like the form's first row. A plain div rather than an `<hr>` -
 * this is a boundary you can see, not a thematic break in the document, and announcing it to a
 * screen reader would be describing the paint.
 */
export function HeaderRule({ gap = 'xs' }: HeaderRuleProps) {
  const { token } = theme.useToken()
  // Lighter than `colorSplit`, which is drawn to separate rows inside a table and reads as a
  // border on the page at full width under a header. Not the faintest fill either: that measures
  // 1.06:1 on white, which is not a subtle line but an absent one.
  return <div aria-hidden style={{ height: 1, marginTop: GAP[gap], background: token.colorFillTertiary }} />
}

export default HeaderRule
